module.exports = __webpack_public_path__ + "h5-static/img/xytable.1776516f.jpg";